import React from "react";
import { Button } from "../../../../Common/Button";
import { Icon } from "../../../../Common/Icons/LucideIcons";
import { MenuButtonsWrapper } from "./__styles__/SubmissionsBuilder";
import { useBuilderFormContext } from "./form";
import {
  SUBMISSIONS_BUILDER_MODE,
  useSubmissionsBuilderMode,
} from "./SubmissionsBuilderContext";

const TEMP_isDisabled = true;
const TEMP_hasVersionHistory = true;

export function MenuButtons() {
  const { formState } = useBuilderFormContext();
  const [mode, setMode] = useSubmissionsBuilderMode();

  const canOpenVersionHistory =
    TEMP_hasVersionHistory &&
    mode === SUBMISSIONS_BUILDER_MODE.BUILD &&
    !formState.isDirty;

  return (
    <MenuButtonsWrapper>
      {mode === SUBMISSIONS_BUILDER_MODE.VERSION_HISTORY ?
        <Button
          styleVariant="outlineLight"
          size="small"
          onClick={() => setMode(SUBMISSIONS_BUILDER_MODE.BUILD)}
        >
          Return to current version
        </Button>
      : canOpenVersionHistory ?
        <Icon
          iconName="history"
          color="contentSecondary"
          size={16}
          cursor="pointer"
          testId="version-history"
          onClick={() => setMode(SUBMISSIONS_BUILDER_MODE.VERSION_HISTORY)}
        />
      : null}
      <Button styleVariant="primary" size="small" disabled={TEMP_isDisabled}>
        Save
      </Button>
    </MenuButtonsWrapper>
  );
}
